import { useMutation } from 'react-query'
import request from '../../request'
import { useDealership } from '../../../store/zustand/dealershipStore'

export const useCreateManualUploadSource = () => {
  const dealership = useDealership()
  return useMutation(({ data }: { data: { sourceName: string; sourceType: string } }) => {
    return request({
      url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/create-manual-upload-source`,
      method: 'POST',
      data: data,
    }).then((res: any) => res.data)
  })
}
